export const ItemTypes = {
  APPOINTMENT: 'appointment',
}
